module.exports = __webpack_public_path__ + "static/media/money_bonus_4.b6b39eca.svg";